import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { setActiveStep } from './utils';

export default function* listenSetActiveStep() {
  yield takeEvery(basketActions.setActiveStep.toString(), setActiveStep);
}
